<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>

            <div class="container-fluid mt-5">
                <!-- Title and Breadcrumb Starts -->
                <div class="row">
                    <div class="col-sm-12 print-media">
                        <vs-breadcrumb align="left" :items="[
                  {
                    title: 'Dashboard',
                    url: '/dashboard/Admin/adminDashboard'
                  },
                  {
                    title: 'Analysis Post Report',
                    active: true
                  }
                ]"></vs-breadcrumb>
                    </div>
                </div>
                <!-- Title and Breadcrumb Ends -->
                <!-- ------------------------------ -->
                <h3 class="text-blue mt-5">{{trainingDetails.title}}</h3>

                <div class="row mt-5">
                    <div class="col-lg-6">
                        <h4 class="text-blue">Event Brief Information</h4>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn btn-primary text-uppercase btn-report float-right ml-3" @click="PrintTrainingDetails">Print Event Details</button>
                        <router-link :to="{ path: '/dashboard/admin/individual_analysis_report', query: { trainingId: this.trainingCode}}" class="btn btn-primary text-uppercase btn-report float-right">Individual Analysis</router-link>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.district != undefined && trainingDetails.district.province != undefined && trainingDetails.district.province.country != undefined">
                        <label class="mr-2 font-weight-bold">Country</label>
                        {{trainingDetails.district.province.country.title}}
                    </div>
                    <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.district != undefined && trainingDetails.district.province != undefined">
                        <label class="mr-2 font-weight-bold">Province</label>
                        {{trainingDetails.district.province.title}}
                    </div>

                    <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.district != undefined">
                        <label class="mr-2 font-weight-bold">City</label>
                        {{trainingDetails.district.title}}
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.advisor != undefined">
                        <label class="mr-2 font-weight-bold">Advisor</label>
                        {{trainingDetails.advisor.name}}
                    </div>

                    <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.programofficer != undefined">
                        <label class="mr-2 font-weight-bold">Program Officer</label>
                        {{trainingDetails.programofficer.name}}
                    </div>

                    <div class="col-sm-4" v-if="trainingDetails != '' && trainingDetails.subprogram != undefined">
                        <label class="mr-2 font-weight-bold">Sub Program / Project</label>
                        {{trainingDetails.subprogram.title}}
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-4" v-if="doners">
                        <label class="mr-2 font-weight-bold">Donor</label>
                        <span v-for="(doner,index) in doners" v-bind:key="index">{{doner.title}} ,</span>
                    </div>

                    <div class="col-sm-8" v-if="alltrainers">
                        <label class="mr-2 font-weight-bold">Trainers</label>
                        <span v-for="(trainer,trIndex) in alltrainers" v-bind:key="trIndex">{{trainer.trainer.name}} ,</span>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-4">
                        <label class="mr-2 font-weight-bold">Start Date</label>
                        {{trainingDetails.startdate}}
                    </div>

                    <div class="col-sm-4">
                        <label class="mr-2 font-weight-bold">End Date</label>
                        {{trainingDetails.enddate}}
                    </div>

                    <div class="col-sm-4">
                        <label class="mr-2 font-weight-bold">No. of Days</label>
                        {{trainingDetails.noofdays}}
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-md-12 text-css">
                        <h4>Detailed Overall Event Analysis</h4>
                    </div>
                </div>
                <div class="form-group row text-css mt-4">
                    <div class="col-sm-3">
                        <h5>total Participants:</h5>
                    </div>
                    <div class="col-sm-9">
                        <p>{{totalCount}}</p>
                    </div>
                </div>
                <div class="row p-lg-3 mt-4 mb-4">
                    <!-- --------------------------  -->
                    <div class="col-lg-3 col-md-3 line-bordered h-100">
                        <table class="table table-borderless mb-0">
                            <thead>
                                <tr>
                                    <th>Departments</th>
                                    <th>No</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="padding:0rem 0.75rem">Male</td>
                                    <td style="padding:0rem 0.75rem">{{maleCount}}</td>
                                </tr>
                                <tr>
                                    <td style="padding:0rem 0.75rem">Female</td>
                                    <td style="padding:0rem 0.75rem">{{femaleCount}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div id="pie-male-female" style="min-height:190px;height: 180px; width: 100%;margin-bottom:20px"></div>
                    </div>
                    <!-- --------------------------  -->
                    <div class="col-lg-4 col-md-4 line-bordered">
                        <table class="table table-borderless mb-0">
                            <thead>
                                <tr>
                                    <th>Departments</th>
                                    <th>No</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(depart,dida) in departmentReport" :key="dida">
                                    <td style="padding:0rem 0.75rem">{{depart.title}}</td>
                                    <td style="padding:0rem 0.75rem">{{depart.count}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- --------------------------  -->
                    <div class="col-lg-4 col-md-4 line-bordered">
                        <table class="table table-borderless mb-0">
                            <thead>
                                <tr>
                                    <th>Participants Designation</th>
                                    <th>No</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(desig,kajds) in designationReport" :key="kajds">
                                    <td style="padding:0rem 0.75rem">{{desig.title}}</td>
                                    <td style="padding:0rem 0.75rem">{{desig.count}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- --------------------------  -->
                <!-- --------------------------  -->
                <div class="row">
                    <div class="col-lg-4 col-md-4 line-bordered text-center" v-for="(question,qindex) in questionsArray" :key="qindex">
                        <div :id="'two_options_graph'+question.id">
                            <h6 class="mt-3 text-dark">{{question.title}}</h6>

                            <div :id="'two-options'+question.id" style="height: 300px; width: 100%;"></div>
                        </div>
                        <!-- exercise-during-training -->
                        <div :id="'three_options_graph'+question.id">
                            <h6 class="mt-3 text-dark">{{question.title}}</h6>
                            <div :id="'three-options'+question.id" style="min-height:300px;height: 300px; width: 100%;margin-bottom:20px"></div>
                        </div>

                        <div :id="'four_options_graph'+question.id">
                            <hr />
                            <h6 class="mt-3 text-dark">{{question.title}}</h6>
                            <div :id="'four-options'+question.id" style="height: 170px; width: 100%;"></div>
                            <hr />
                        </div>
                        <div :id="'five_options_graph'+question.id">
                            <hr />
                            <h6 class="mt-3 text-dark">{{question.title}}</h6>
                            <div :id="'five-options'+question.id" style="height: 170px; width: 100%;"></div>
                            <hr />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Highcharts from "../../../../public/highcharts";
import $ from 'jquery';


export default {
    data: () => ({
        isSidebar: false,
        trainingDetails: [],
        alltrainers: [],
        doners: [],
        maleCount: 0,
        femaleCount: 0,
        totalCount: 0,
        trainingID: "",
        checkBox1: false,
        basepath: process.env.VUE_APP_BASE_PATH,
        checkBox2: false,
        checkBox3: false,
        checkBox4: false,
        questions: [],
        departmentReport: [],
        designationReport: [],
        labelArray: [],
        selectedOptions: [],
        questionsArray: [],
        counterSelectedOptions: 0,
        counterA: 0,

    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                if (response.data && response.data.training) {
                    this.trainingDetails = response.data.training;
                    this.trainingID = response.data.training.id;
                    this.showTrainers(response.data.training.id);
                    this.showMaleFemale(response.data.training.id);
                    this.DepartmentData(response.data.training.id);
                    this.DesignationData(response.data.training.id);
                    this.allStandardQuestions(response.data.training.id);
                    if (response.data && response.data.doner) {
                        this.doners = response.data.doner;
                    }
                    //this.showTrainees(response.data.training.id);
                }
            });

    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    methods: {
        allStandardQuestions: function allStandardQuestions(tId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/training/standardPostQuestions/all/get/" +
                    tId
                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (
                        response.data &&
                        response.data.preassesment &&
                        response.data.options
                    ) {
                        setTimeout(() => {
                            response.data.questions.forEach((element) => {
                                response.data.options.forEach((opt) => {
                                    this.labelArray = [];
                                    this.selectedOptions = [];
                                    opt.forEach((oneopt, optindex) => {
                                        if (oneopt.questionBank_id == element.id) {
                                            this.selectedOptions.push(0);
                                            response.data.preassesment.forEach((asses) => {
                                                if (asses.option_id == oneopt.id) {
                                                    this.selectedOptions[optindex] =
                                                        this.selectedOptions[optindex] + 1;
                                                }
                                            });

                                            if (opt.length == optindex + 1) {
                                                this.labelArray.push(oneopt);
                                                if (this.labelArray && this.labelArray.length == 2) {
                                                    $(
                                                        "#three_options_graph" + element.id
                                                    ).hide();
                                                    $("#four_options_graph" + element.id).hide();
                                                    $("#five_options_graph" + element.id).hide();
                                                    Highcharts.chart(
                                                        "two-options" + element.id, {
                                                            chart: {
                                                                plotBackgroundColor: null,
                                                                plotBorderWidth: null,
                                                                plotShadow: false,
                                                                type: "pie"
                                                            },
                                                            title: {
                                                                text: ""
                                                            },
                                                            tooltip: {
                                                                pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                                                            },
                                                            plotOptions: {
                                                                pie: {
                                                                    allowPointSelect: true,
                                                                    cursor: "pointer",
                                                                    dataLabels: {
                                                                        enabled: false
                                                                    },
                                                                    showInLegend: true
                                                                }
                                                            },
                                                            series: [{
                                                                name: "Answer",
                                                                colorByPoint: true,
                                                                data: [{
                                                                        name: this.labelArray[0],
                                                                        y: this.selectedOptions[0],
                                                                        color: "#604a7b"
                                                                    },
                                                                    {
                                                                        name: this.labelArray[1].title,
                                                                        y: this.selectedOptions[1],
                                                                        color: "#558ed5"
                                                                    }
                                                                ]
                                                            }]
                                                        }
                                                    );
                                                } else if (
                                                    this.labelArray &&
                                                    this.labelArray.length == 4
                                                ) {
                                                    $(
                                                        "#three_options_graph" + element.id
                                                    ).hide();
                                                    $("#two_options_graph" + element.id).hide();
                                                    $("#five_options_graph" + element.id).hide();
                                                    Highcharts.chart(
                                                        "four-options" + element.id, {
                                                            chart: {
                                                                type: "bar"
                                                            },
                                                            title: {
                                                                text: "Stacked bar chart"
                                                            },
                                                            xAxis: {
                                                                categories: [""]
                                                            },
                                                            yAxis: {
                                                                min: 0
                                                            },
                                                            legend: {
                                                                reversed: true
                                                            },
                                                            plotOptions: {
                                                                series: {
                                                                    stacking: "percent"
                                                                }
                                                            },
                                                            series: [{
                                                                    name: this.labelArray[0],
                                                                    data: [this.selectedOptions[0]]
                                                                },
                                                                {
                                                                    name: this.labelArray[1],
                                                                    data: [this.selectedOptions[1]]
                                                                },
                                                                {
                                                                    name: this.labelArray[2],
                                                                    data: [this.selectedOptions[2]]
                                                                },
                                                                {
                                                                    name: this.labelArray[3].title,
                                                                    data: [this.selectedOptions[3]]
                                                                }
                                                            ]
                                                        }
                                                    );
                                                } else if (
                                                    this.labelArray &&
                                                    this.labelArray.length == 3
                                                ) {
                                                    $("#four_options_graph" + element.id).hide();
                                                    $("#two_options_graph" + element.id).hide();
                                                    $("#five_options_graph" + element.id).hide();
                                                    Highcharts.chart(
                                                        "three-options" + element.id, {
                                                            chart: {
                                                                type: "column"
                                                            },
                                                            title: {
                                                                text: "Stacked column chart"
                                                            },
                                                            xAxis: {
                                                                categories: ["Practicals"]
                                                            },
                                                            yAxis: {
                                                                min: 0,
                                                                stackLabels: {
                                                                    enabled: false,
                                                                    style: {
                                                                        fontWeight: "bold",
                                                                        color:
                                                                            // theme
                                                                            (Highcharts.defaultOptions.title.style &&
                                                                                Highcharts.defaultOptions.title.style
                                                                                .color) ||
                                                                            "gray"
                                                                    }
                                                                }
                                                            },
                                                            legend: {
                                                                align: "center",
                                                                x: -30,
                                                                verticalAlign: "bottom",
                                                                y: 15,
                                                                floating: false,
                                                                backgroundColor: Highcharts.defaultOptions.legend
                                                                    .backgroundColor || "white",
                                                                borderColor: "#CCC",
                                                                borderWidth: 1,
                                                                shadow: false
                                                            },
                                                            tooltip: {
                                                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                                                                shared: true
                                                            },
                                                            plotOptions: {
                                                                column: {
                                                                    stacking: "percent",
                                                                    dataLabels: {
                                                                        enabled: true
                                                                    }
                                                                }
                                                            },
                                                            series: [{
                                                                    name: this.labelArray[0],
                                                                    data: [this.selectedOptions[0]],
                                                                    color: "#4572a7"
                                                                },
                                                                {
                                                                    name: this.labelArray[1],
                                                                    data: [this.selectedOptions[1]],
                                                                    color: "#89a54e"
                                                                },
                                                                {
                                                                    name: this.labelArray[2],
                                                                    data: [this.selectedOptions[2]],
                                                                    color: "#aa4643"
                                                                }
                                                            ]
                                                        }
                                                    );
                                                } else {
                                                    $("#two_options_graph" + element.id).hide();
                                                    $(
                                                        "#three_options_graph" + element.id
                                                    ).hide();
                                                    $("#four_options_graph" + element.id).hide();
                                                    Highcharts.chart(
                                                        "five-options" + element.id, {
                                                            chart: {
                                                                type: "column"
                                                            },
                                                            title: {
                                                                text: "Stacked column chart"
                                                            },
                                                            xAxis: {
                                                                categories: ["Practicals"]
                                                            },
                                                            yAxis: {
                                                                min: 0,
                                                                stackLabels: {
                                                                    enabled: false,
                                                                    style: {
                                                                        fontWeight: "bold",
                                                                        color:
                                                                            // theme
                                                                            (Highcharts.defaultOptions.title.style &&
                                                                                Highcharts.defaultOptions.title.style
                                                                                .color) ||
                                                                            "gray"
                                                                    }
                                                                }
                                                            },
                                                            legend: {
                                                                align: "center",
                                                                x: -30,
                                                                verticalAlign: "bottom",
                                                                y: 15,
                                                                floating: false,
                                                                backgroundColor: Highcharts.defaultOptions.legend
                                                                    .backgroundColor || "white",
                                                                borderColor: "#CCC",
                                                                borderWidth: 1,
                                                                shadow: false
                                                            },
                                                            tooltip: {
                                                                pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
                                                                shared: true
                                                            },
                                                            plotOptions: {
                                                                column: {
                                                                    stacking: "percent",
                                                                    dataLabels: {
                                                                        enabled: true
                                                                    }
                                                                }
                                                            },
                                                            series: [{
                                                                    name: this.labelArray[0],
                                                                    data: [this.selectedOptions[0]],
                                                                    color: "#4572a7"
                                                                },
                                                                {
                                                                    name: this.labelArray[1],
                                                                    data: [this.selectedOptions[1]],
                                                                    color: "#89a54e"
                                                                },
                                                                {
                                                                    name: this.labelArray[2],
                                                                    data: [this.selectedOptions[2]],
                                                                    color: "#aa4643"
                                                                }
                                                            ]
                                                        }
                                                    );
                                                }
                                            } else {
                                                this.labelArray.push(oneopt.title);
                                            }
                                        }
                                        this.counterA++;
                                    });
                                });
                            });
                        }, 200);
                        this.questionsArray = response.data.questions;
                    }
                });
        },
        DepartmentData: function DepartmentData(tId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/department/data/" +
                    tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.departmentReport = response.data;
                });
        },
        DesignationData: function DesignationData(tId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/designation/data/" +
                    tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.designationReport = response.data;
                });
        },
        showTrainers: function showTrainers(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/trainer/get/" +
                    tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.alltrainers = response.data;
                });
        },
        showMaleFemale: function showMaleFemale(tId) {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/single/training/traineedetails/report/gender/get/" +
                    tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.maleCount = response.data.male;
                    this.femaleCount = response.data.female;
                    this.totalCount = response.data.genderCount;
                    this.genderChart();
                });
        },
        genderChart: function genderChart() {
            Highcharts.chart("pie-male-female", {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: "pie"
                },
                title: {
                    text: ""
                },
                tooltip: {
                    pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                accessibility: {
                    point: {
                        valueSuffix: "%"
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: "pointer",
                        // colors: pieColors,
                        dataLabels: {
                            enabled: true,
                            format: "<b>{point.name}</b><br>{point.percentage:.1f} %",
                            distance: -35,
                            filter: {
                                property: "percentage",
                                operator: ">",
                                value: 4
                            }
                        }
                    }
                },
                series: [{
                    name: "Share",
                    data: [{
                            name: "Male",
                            y: this.maleCount,
                            color: "#e74f5c"
                        },
                        {
                            name: "Female",
                            y: this.femaleCount,
                            color: "#36b4e7"
                        }
                    ]
                }]
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {

            this.$vs.loading.close();
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        formSubmitted() {
            alert("Form submitted!");
        },
        next: function () {
            if (this.currentQ + 1 < this.questions.length) {
                this.currentQ++;
            }
        },
        PrintTrainingDetails: function () {
            window.print();
        }
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

li {
    list-style-type: none !important;
}

.f-500 {
    font-weight: 500;
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #f9f9f9;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

.vs-popup--background {
    opacity: 0.3 !important;
}

.con-img-upload .img-upload {
    width: 150px !important;
}

.mt-10 {
    margin-top: 78px;
}

.line-bordered {
    border-top: 2px solid #6c757d;
    border-bottom: 2px solid #6c757d;
    border-left: 1px solid #6c757d;
    border-right: 1px solid #6c757d;
}

.text-css h4 {
    color: #009ad2;
    text-transform: capitalize;
}

.text-css h5 {
    color: #6c757d;
    text-transform: capitalize;
}

.text-css h6 {
    color: #6c757d;
    text-transform: capitalize;
}

.text-css p {
    color: #6c757d;
    font-size: 18px;
    font-weight: 700;
    text-transform: capitalize;
}

.text-blue {
    color: #00a4ea;
}

.btn-report {
    background-color: #6488d2 !important;
    border-radius: 0px !important;
    padding: 3px 30px !important;
}

.highcharts-credits {
    display: none !important;
}

.highcharts-title {
    display: none !important;
}

.div#highcharts-4bv8m9d-0 {
    z-index: -5 !important;
}

@media print {
    #page-content-wrapper {
        overflow: visible  !important;
        height: auto !important;
    }

    .btn-report {
        display: none
    }

    .print-media {
        display: none;
    }
}
</style>
